import { ReactElement } from "react";
import Register from "Pages/Auth/Register";
import Login from "Pages/Auth/Login";
import About from "Pages/About/about";
import Profile from "Pages/Profile/Index";
import AdminLayout from "ThemeLayout/AdminLayout";
import AdminLogin from "Pages/Admin/AdminLogin";
import { Outlet, RouteObject } from "react-router-dom";
import AdminDashboard from "Pages/Admin/AdminDashboard";
import Users from "Pages/Admin/Users";
import Home from "Pages/Home/Home";
import Contact from "Pages/contact/Contact";
import UserFormData from "Pages/Admin/UserFormData";
import ChatPage from "Pages/chatpage";
import SignUp from "Pages/Auth/SignUp";

export interface RouteProps {
    path: string;
    element: ReactElement;
}

const routes: RouteProps[] = [
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/profile", element: <Profile /> },
    { path: "/contact", element: <Contact /> },
    
];

const nonAuthRoutes: RouteProps[] = [
    { path: "/register", element: <SignUp/> },
    { path: "/login", element: <Login /> },
    { path: "/chatbot", element: <ChatPage /> },
    { path: "/chatbot/:tabId", element: <ChatPage /> },
    // { path: "/order-success", element: <OrderSuccess /> },
    // { path: "/reset-password", element: <ResetPassword /> },
]

// const billingRoutes: RouteObject = {
//     path: "/billing",
//     element: <BillingLayout><Outlet /></BillingLayout>,
//     children: [
//         { path: "overview", element: <Overview /> },
//         { path: "history", element: <History /> },
//         // { path: "payment-method", element: <PaymentMethod /> },

//     ]
// }

const adminRoutes: RouteObject = {
    path: "/admin",
    element: <AdminLayout><Outlet /></AdminLayout>,
    children: [
        { path: "login", element: <AdminLogin /> },
        { path:"dashboard", element: <AdminDashboard /> },
        // { path:"settings", element: <Settings /> },
        // { path:"orders", element: <Order /> },
        { path:"users-info", element: <Users /> },
        // { path:"user-detail/:id", element: <UserDetails /> },
        { path:"form", element: <UserFormData /> },
    ]
};

export {
    routes,
    nonAuthRoutes,
    adminRoutes,
    // billingRoutes
};
